import { Text } from '@chakra-ui/react';
import { useEffect } from 'react';

import Modal from '../../../../../../components/Modal';
import {
  BuyoutOverlaySource,
  trackBuyoutOverlayOpened,
} from '../../../../../../services/analytics/marketplaceEvents';
import BuyoutCallButton from './BuyoutCallButton';

type BuyoutCallModalProps = {
  isOpen: boolean;
  onClose: () => void;
  source: BuyoutOverlaySource;
  model?: string | null;
  dealId: string;
  leadId: string;
};

const BuyoutCallModal = ({
  isOpen,
  onClose,
  source,
  model,
  dealId,
  leadId,
}: BuyoutCallModalProps) => {
  useEffect(() => {
    if (isOpen) trackBuyoutOverlayOpened(dealId, leadId, source);
  }, [isOpen, dealId, leadId, source]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Keep your car."
      titleFontSize={{ base: '22px', md: '26px' }}
      titleFontWeight="700"
      _content={{ maxW: '480px' }}
      _body={{ pb: '28px' }}
    >
      <Text fontSize="13.5px" color="charcoal" lineHeight="1.6">
        Own your {model || 'car'} outright. Our buyout team walks you through your exact numbers,
        financing, and next steps, and it starts with one call.
      </Text>
      <BuyoutCallButton
        source={source}
        dealId={dealId}
        leadId={leadId}
        isFullWidth
        display="block"
        mt="20px"
      />
    </Modal>
  );
};

export default BuyoutCallModal;
